/**
 * Recent search history, persisted in localStorage. Newest-first, de-duped
 * case-insensitively, capped at MAX. All reads/writes are SSR-safe and
 * swallow storage errors (private mode / quota / disabled storage).
 */
export const RECENT_SEARCHES_KEY = '1anime:recent-searches';
const MAX = 8;

export function getRecentSearches(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((v): v is string => typeof v === 'string')
      .slice(0, MAX);
  } catch {
    return [];
  }
}

function write(list: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      RECENT_SEARCHES_KEY,
      JSON.stringify(list.slice(0, MAX))
    );
  } catch {
    /* quota / disabled — ignore */
  }
}

export function addRecentSearch(query: string): string[] {
  const trimmed = query.trim();
  if (!trimmed) return getRecentSearches();
  const lower = trimmed.toLowerCase();
  const rest = getRecentSearches().filter((q) => q.toLowerCase() !== lower);
  const next = [trimmed, ...rest].slice(0, MAX);
  write(next);
  return next;
}

export function removeRecentSearch(query: string): string[] {
  const lower = query.toLowerCase();
  const next = getRecentSearches().filter((q) => q.toLowerCase() !== lower);
  write(next);
  return next;
}

export function clearRecentSearches(): string[] {
  write([]);
  return [];
}
